import { useEffect } from 'react';

var optionsArraysDiff = function optionsArraysDiff(arrayOne, arrayTwo) {
  return arrayOne.filter(function (_ref) {
    var value1 = _ref.value,
        label1 = _ref.label;
    return !arrayTwo.some(function (_ref2) {
      var value2 = _ref2.value,
          label2 = _ref2.label;
      return value1 === value2 && label1 === label2;
    });
  });
};

export var useOnOptionListUpdate = function useOnOptionListUpdate(internalOptions, dynamicInternalOptions, setInternalValue) {
  return useEffect(function () {
    if (internalOptions.length !== dynamicInternalOptions.length || optionsArraysDiff(internalOptions, dynamicInternalOptions).length) {
      setInternalValue([]);
    }
  }, [internalOptions, dynamicInternalOptions, setInternalValue]);
};